import { match } from 'ts-pattern';
import { INSTAGRAM_CONTENT_TYPES, SOCIAL_PLATFORMS } from '~/constants';
import {
  ASSET_TYPE,
  ISearchContentResult,
  YOUTUBE_ASSET_SIZE,
} from '~/searchApi';

export const getContentLink = (content: ISearchContentResult) => {
  return match(content.platform)
    .with(SOCIAL_PLATFORMS.instagram, () => content.shareUrl)
    .with(SOCIAL_PLATFORMS.tiktok, () => content.externalUrl)
    .with(
      SOCIAL_PLATFORMS.youtube,
      () => ` https://www.youtube.com/watch?v=${content.networkId}`,
    )
    .exhaustive();
};

export const getIsStoryExpired = (content: ISearchContentResult) => {
  const { publishedAt, createdTime } = content;
  if (
    content.platform === SOCIAL_PLATFORMS.instagram &&
    content.channel === INSTAGRAM_CONTENT_TYPES.story
  ) {
    const hoursInMilliseconds = 24 * 60 * 60 * 1000;
    const currentDate = new Date();
    const createDate = new Date(publishedAt ?? createdTime);

    return currentDate.getTime() - createDate.getTime() > hoursInMilliseconds;
  }
  return false;
};

export const getContentPreviewUrl = (content: ISearchContentResult) => {
  return match(content.type)
    .with(ASSET_TYPE.video, () => {
      const asset = match(content.platform)
        .with(SOCIAL_PLATFORMS.youtube, () => {
          // For youtube, we need to use the high quality asset
          return (
            content.assets.find(
              ({ name }) => YOUTUBE_ASSET_SIZE.high === name,
            ) || content.assets.at(0)
          );
        })
        .otherwise(() => content.assets.at(0));
      return asset?.previewUrl || asset?.thumbnail || asset?.url;
    })
    .otherwise(() => {
      return (
        content.assets.at(0)?.url ||
        content.assets.at(0)?.previewUrl ||
        content.assets.at(0)?.thumbnail
      );
    });
};
